
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'helpers/ModuleHelper';
import MediaBox from 'components/MediaBox/MediaBox';
import ContainerBox from 'layouts/UIElements/ContainerBox/ContainerBox';
import { sliceText } from 'helpers/FieldHelper';
import Spinner from 'layouts/UIElements/Spinner/Spinner';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { injectIntl } from 'react-intl';
import { Flow } from 'flow-react';
import { observer } from 'mobx-react';
import * as ConfigTypes from 'config/ConfigTypes';
import { isAudio } from 'helpers/AppHelper';
import * as actions from 'store/actions';
import VideoPlayer from 'components/VideoPlayer/VideoPlayer';
import { getMetaConfig } from "helpers/ConfigHelper";
import { getBaseName, isLocal, isHome } from "helpers/AppHelper";
import { parseStringField, checkGroupFields, ElementWrapper, showElementMetaBox }
    from "helpers/FieldHelper";
import { isWorkOfLane } from 'helpers/LaneHelper';
import './HomeView.scss';

const HomeView = observer(
    class HomeView extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                loading: false,
                popUpType: 'infoType',
                contentClass: this.getScrollClass(),
                txtFs: ConfigTypes.FONTSIZE_TXT,
                headingFs: ConfigTypes.FONTSIZE_H1,
                viewMode: ConfigTypes.HOME,
                autoplay: true,
                loop: true,
                willMount: true
            }
        }

        getScrollClass = () => {
            if (isAudio()) return "homeview-scroll-audio";
            return "homeview-scroll";
        }

        onHeadingEnter = () => this.setState({ contentClass: "homeview-content" });
        onHeadingLeave = () => this.setState({ contentClass: this.getScrollClass() });

        isClicked = () => {
            const { currentWork, currentClip, currentTrailer } = this.props.mediaObjects;
            if (currentWork && (currentClip && currentTrailer && currentClip.id != currentTrailer.id)) {
                return true;
            }
            return false;
        }

        clickPlayerTitle = () => {
            const { currentWork } = this.props.mediaObjects;
            if (this.isClicked()) {
                this.props.updateMediaObjects({ loading: true });
                let url = window.location.origin;
                if (isLocal()) url += `${ConfigTypes.WORK_PATH}/${currentWork.id}`;
                else url += getBaseName() + `${ConfigTypes.WORK_PATH}/${currentWork.id}`;
                window.location.replace(url);
            }
        }

        getUrl = (data) => {
            let source = null;
            if (data.mediafiles.elements) {
                data.mediafiles.elements.forEach(file => {
                    const tags = file.getTags();
                    if (tags && tags.indexOf('preview') !== -1) {
                        source = file.getUrl();
                    }
                });
            }
            return source;
        }

        getCreatedDate = () => {
            let datestring = '';
            let time = '';
            if (this.state.clip.metadata.fields.created) {
                let value = this.state.clip.metadata.fields.created;
                let dt = "";
                if (value) {
                    if (value.includes(".") && value.split(".").length == 3) return value;
                    dt = new Date(value);
                    datestring = ("0" + dt.getDate()).slice(-2) + "/" + ("0" + (dt.getMonth() + 1)).slice(-2) + "/" +
                        dt.getFullYear();
                    time = ("0" + dt.getHours()).slice(-2) + ":" + ("0" + dt.getMinutes()).slice(-2);

                }
                return { date: datestring, time: time };
            }
        }

        formatMessage = ({ id }) => {
            return this.props.intl.formatMessage({ id });
        }

        handleDownload = () => {
            let url = this.state.clip.mediafiles.elements[0].url;
            window.location = url;
        }

        cancelCallback = () => {
            this.setState({ showSocial: false });
        }

        confirmCallback = () => {
            this.handleDownload();
            this.props.updateMediaObjects({ mediaActions: { showOverlay: false } });
        }

        updateClip = () => {
            const { currentClip, currentTrailer } = this.props.mediaObjects;
            if (this.state.willMount && this.state.isTrailer) {
                this.playCurrentTrailer({ trailerObj: currentTrailer });
            } else {
                if (currentClip) {
                    this.setState({ currentClip: currentClip });
                    console.log("LOGS: currentClip ", currentClip);
                }
            }
        }

        setPlayerOffset = () => {
            if (this.props.mediaObjects.playerOffset) {
                let headingEl = document.querySelector('.homeview-heading');
                let heading;
                if (headingEl) heading = headingEl.offsetHeight;
                let playerOffset = this.props.mediaObjects.playerOffset + heading + ConfigTypes.BOTTOM_SPACE;
                if (playerOffset) this.setState({ playerOffset });
            }
        }

        // AUTOPLAY AND LOOP BEGIN
        getSubTrailer = () => {
            const { currentLane } = this.props.mediaObjects;
            let laneTrailer = this.props.mediaObjects[`${ConfigTypes.LANE}${currentLane.id}Trailer`];
            if (ConfigTypes.SUB_TRAILER == true && laneTrailer) {
                return laneTrailer;
            }
            return false;
        }

        playCurrentTrailer = ({ trailerObj, isSub }) => {
            const { homeObj } = this.props.mediaObjects;
            if (trailerObj && (homeObj.trailerStart || isSub)) {
                console.log("LOGS: PLAYCURRENTTRAILER trailerObj", trailerObj);
                let obj = {
                    homeObj: {
                        ...homeObj, autoplay: true, loop: true,
                        trailerStart: false, trailerObj
                    },
                    currentClip: trailerObj
                }

                let subTrailer = this.getSubTrailer();
                if (subTrailer) {
                    obj.currentClip = subTrailer;
                    obj.homeObj.trailerObj = subTrailer;
                }
                this.props.updateMediaObjects(obj);

                this.setState({
                    currentClip: trailerObj,
                    clip: trailerObj, loading: true,
                    autoplay: true, loop: true, isTrailer: true,
                }, () => setTimeout(() => this.setState({ loading: false }), 100));
            }
        }

        setPlayerDefault = () => {
            console.log("LOGS: SET PLAYER DEFAULT");
            const { homeObj } = this.props.mediaObjects;
            this.props.updateMediaObjects({ homeObj: { ...homeObj, autoplay: false, loop: false } });
            this.setState({ autoplay: false, loop: false, willMount: false });
        }

        getExtraLaneTrailer = () => {
            const { extraLane } = this.props.mediaObjects;
            this.props.getLane({ laneId: extraLane.id, isExtra: true });
        }

        getAllLaneTrailers = () => {
            if (ConfigTypes.SUB_TRAILER == true) {
                const { laneTree } = this.props.mediaObjects;
                if (laneTree && laneTree.length) {
                    laneTree.forEach(lane => {
                        this.props.getLane({ laneId: lane.id, isExtra: false });
                    })
                }
            }
        }

        setWorkAsCurrent = () => {
            const { currentWork } = this.props.mediaObjects;
            this.setState({
                currentClip: currentWork,
                clip: currentWork, loading: true,
            }, () => this.setState({ loading: false }));
        }


        setClipAsCurrent = () => {
            const { currentClip, currentLane, trailerLane, currentTrailer, trailerPlaying, currentWork, laneChanging }
                = this.props.mediaObjects;
            if (currentClip && currentClip.id) {
                if (isWorkOfLane({ mediaObjects: this.props.mediaObjects, workId: currentClip.id })) {
                    console.log("LOGS: setClipAsCurrent");
                    if (trailerPlaying || (currentWork && currentWork.id == currentClip.id && !laneChanging)
                    ) {
                        if (currentWork && currentWork.id == currentClip.id && !laneChanging) {
                            this.props.getWork({ workId: currentClip.id, isHome: true });
                        }
                    } else {
                        let subTrailer = this.getSubTrailer();
                        if (subTrailer && laneChanging) {
                            this.playCurrentTrailer({ trailerObj: subTrailer, isSub: true });
                        }
                        else {
                            this.setState({ autoplay: true, isTrailer: false });
                            this.props.getWork({ workId: currentClip.id, isHome: true });
                        }
                    }
                    if (laneChanging) this.props.updateMediaObjects({ laneChanging: false });
                    if (currentLane && currentLane.id == trailerLane.id && !this.state.willMount) {
                        this.setState({ autoplay: true, isTrailer: false });
                        if (currentClip && currentClip.id
                            && currentClip.id != currentTrailer.id) {
                            this.props.updateMediaObjects({ laneEnabled: true });
                        }
                    }
                }
                this.setState({ currentClip, clip: currentClip, loading: true }, () => this.setState({ loading: false }));
            }
        }

        checkLane = () => {
            const { currentLane, currentTrailer, trailerLane, clickedLane }
                = this.props.mediaObjects;
            if (currentLane.id == trailerLane.id) {
                if (clickedLane && clickedLane.id == trailerLane.id) {
                    this.setState({ autoplay: true, isTrailer: false });
                } else {
                    this.setState({ autoplay: true, isTrailer: true });
                    this.playCurrentTrailer({ trailerObj: currentTrailer });
                }
            } else {
                let subTrailer = this.getSubTrailer();
                if (subTrailer) {
                    this.setState({ autoplay: true, isTrailer: true });
                } else {
                    if (!isHome()) this.props.router.navigate("/");
                    this.setState({ autoplay: true, isTrailer: false });
                }
            }
            let subTrailer = this.getSubTrailer();
            if (subTrailer) this.props.updateMediaObjects({ trailerPlaying: true });
            this.props.updateMediaObjects({ trailerPlaying: false });
        }

        checkAutoChanged = () => {
            const { currentTrailer } = this.props.mediaObjects;
            this.setState({ autoplay: true, isTrailer: true });
            this.playCurrentTrailer({ trailerObj: currentTrailer });
            this.props.updateMediaObjects({ autoChanged: false });
        }

        checkLaneLooped = () => {
            let subTrailer = this.getSubTrailer();
            if (subTrailer) {
                this.setState({ autoplay: true, isTrailer: true });
                this.playCurrentTrailer({ trailerObj: subTrailer });
                this.props.updateMediaObjects({ laneLooped: false });
            }
        }

        checkClickedLane = () => {
            const { trailerLane, clickedLane, lanes, currentLane }
                = this.props.mediaObjects;
            if (clickedLane.id == trailerLane.id && !this.state.willMount) {
                this.props.getWork({ workId: lanes[currentLane.id][0], isHome: true });
                this.setState({ autoplay: true, isTrailer: false });
            }
        }

        handleLanes = (prev) => {
            const { extraLane, currentLane, clickedLane, laneTree, autoChanged, laneLooped }
                = this.props.mediaObjects;
            if (prev.mediaObjects.extraLane != extraLane) {
                this.getExtraLaneTrailer();
            }
            if (prev.mediaObjects.laneTree != laneTree) {
                this.getAllLaneTrailers();
            }
            if (prev.mediaObjects.currentLane != currentLane) {
                this.checkLane();
            }
            if (!prev.mediaObjects.clickedLane && clickedLane) {
                this.checkClickedLane();
            }
            if (!prev.mediaObjects.autoChanged && autoChanged && !this.state.willMount) {
                this.checkAutoChanged();
            }
            if (!prev.mediaObjects.laneLooped && laneLooped && !this.state.willMount) {
                this.checkLaneLooped();
            }
        }

        controlPlayer = (prev) => {
            const { currentClip, currentWork, homeObj, currentTrailer } = this.props.mediaObjects;
            if (prev.mediaObjects.currentClip != currentClip && !this.state.willMount) {
                this.setClipAsCurrent();
            }
            if (prev.mediaObjects.currentWork != currentWork) {
                this.props.updateMediaObjects({ trailerWaiting: false });
                this.setWorkAsCurrent();
            }
            // Lanes
            this.handleLanes(prev);

            if (prev.mediaObjects.homeObj.trailerStart != homeObj.trailerStart) {
                this.props.updateMediaObjects({ currentClip: homeObj.trailerObj });
                this.playCurrentTrailer({ trailerObj: homeObj.trailerObj });
            }
            if (prev.mediaObjects.currentTrailer != currentTrailer && this.state.willMount) {
                this.playCurrentTrailer({ trailerObj: currentTrailer });
            }
        }
        // AUTOPLAY AND LOOP END

        componentDidUpdate(prev) {

            this.controlPlayer(prev);

            if (prev.mediaObjects.playerOffset != this.props.mediaObjects.playerOffset) {
                this.setPlayerOffset();
            }
            if (prev.mediaObjects.fsSettings != this.props.mediaObjects.fsSettings) {
                let fs = this.props.mediaObjects.fsSettings;
                this.setState({
                    txtFs: ConfigTypes.FONTSIZE_TXT + fs,
                    headingFs: ConfigTypes.FONTSIZE_H1 + fs
                });
            }
        }

        componentDidMount() {
            if (this.props.mediaObjects.playerOffset) {
                this.setPlayerOffset();
            }
            this.updateClip();
        }

        componentWilUnmount = () => { }

        showPlayer = () => {
            const { loading } = this.props.mediaObjects;
            if ((!this.state.loading && this.state.currentClip && !loading)
                || (this.props.mediaObjects.openVideoPlayer)) {
                // if (!this.state.loading && this.state.currentClip && !loading) {
                return (
                    <VideoPlayer isAutoPlay={this.state.autoplay} isTrailer={this.state.isTrailer} isLoop={this.state.loop}
                        getSubTrailer={this.getSubTrailer} setPlayerDefault={this.setPlayerDefault} />
                )
            }
        }

        showClipTextRow = ({ el, i, isGroup = false }) => {
            let clip = this.state.currentClip;
            let viewMode = this.state.viewMode;

            if (isGroup && el[`${this.state.viewMode}group`].isHeading) {
                return (
                    <ElementWrapper el={el} i={i} viewMode={viewMode} key={`clipdetailClipText${i}`}>
                        <h1>
                            {parseStringField(clip.metadata.fields[el.field])}
                            {checkGroupFields({ isGroup, el, clip, viewMode })}
                        </h1>
                    </ElementWrapper>)
            }

            if (el[`${this.state.viewMode}labelField`]) {
                return this.showClipLabelText({ el, i, viewMode })
            }

            return (
                <ElementWrapper el={el} viewMode={viewMode} key={`clipdetailClipText${i}`}>
                    <div className="row clipdetail-content-row">
                        <div className="col-lg-5 col-md-4 col-sm-4">
                            {this.props.intl.formatMessage({ id: el.intl })}
                        </div>
                        {this.getClipText({ isGroup, el, clip, viewMode })}
                    </div>
                </ElementWrapper>
            )
        }

        showContentBox = ({ showFields }) => {
            return showFields.map((item, i) => {
                let desc = item[`${this.state.viewMode}description`] || false;
                let heading = item[`${this.state.viewMode}heading`] || false;
                let isGroup = item[`${this.state.viewMode}group`];
                let filterType = item[`${this.state.viewMode}filterType`] || false;
                if (heading) {
                    return showElementMetaBox({
                        el: item, i, viewMode: this.state.viewMode, isGroup,
                        element: this.state.currentClip, formatMessage: this.formatMessage,
                        titleClass: this.isClicked() && "homeview-mainheading",
                        onHeadingClick: this.clickPlayerTitle
                    });
                }
                if (desc) {
                    let homeDesc = parseStringField(this.state.currentClip.metadata.fields[item.field])
                    return (
                        <div className="homeview-scroll">
                            {(homeDesc && homeDesc.length) ? sliceText(homeDesc, 500)
                                : (
                                    <div>
                                        <p>{ConfigTypes.TEST_CONTENT_1}</p>
                                    </div>)}
                        </div>)
                }
            })
        }

        showHomeContent = () => {
            const showFields = getMetaConfig({
                viewMode: this.state.viewMode, props: this.props, configName: ConfigTypes.WORK
            });
            if (this.state.currentClip && this.state.currentClip.metadata
                && this.state.currentClip.metadata.fields) {
                return (
                    <Fragment>
                        <div className="homeview-playerbox">
                            {this.showPlayer()}
                        </div>
                        <div className="row">
                            {this.showContentBox({ showFields })}
                        </div>
                    </Fragment>
                )
            }
        }


        render() {
            return (
                <ContainerBox>
                    {this.showHomeContent()}
                    {this.props.loading && (
                        <div className="homeview-overlay">
                            <Spinner />
                        </div>)}
                </ContainerBox>)
        }
    }
)

const mapStateToProps = (state) => ({
    mediaObjects: state.media.mediaObjects,
    loading: state.media.mediaObjects.loading,
    configObjects: state.config.configObjects
});

const mapDispatchToProps = (dispatch) => ({
    updateMediaObjects: (obj) => dispatch(actions.updateMediaObjects(obj)),
    updateAppObjects: (obj) => dispatch(actions.updateAppObjects(obj)),
    getWork: (data) => dispatch(actions.getWork(data)),
    getLane: (data) => dispatch(actions.getLane(data))
})

export default Flow.injectFlow(connect(mapStateToProps, mapDispatchToProps)(withRouter(injectIntl(HomeView))));